import { render } from "./Disabled.vue?vue&type=template&id=4b8efde7"
const script = {}

import "./Disabled.vue?vue&type=style&index=0&id=4b8efde7&lang=css"
script.render = render

export default script